/**
 * Created by daniel on 17/04/17.
 *
 * Returns a style element
 *
 * Useful info for dev:
 * - Outlook styles support: https://msdn.microsoft.com/en-us/library/aa338201(v=office.12).aspx#Word2007MailHTMLandCSS_Full
 * - Mailchimp reset: https://templates.mailchimp.com/development/css/reset-styles/
 * - Mailchimp style support list: https://templates.mailchimp.com/resources/email-client-css-support/
 * - HTML 4 spec: https://www.w3.org/TR/REC-html40/
 * - Generic css reset: http://cssreset.com/scripts/eric-meyer-reset-css/
 * - Inherited CSS properties: http://stackoverflow.com/questions/5612302/which-css-properties-are-inherited
 *
 * Dependency info
 * - Juice style inliner: https://github.com/Automattic/juice
 * - Juice test sandbox: http://automattic.github.io/juice/
 * - JSS js stylesheet generator: https://www.npmjs.com/package/jss
 *
 */

import React, {Component} from 'react';
import {create} from 'jss';

class StyleItem extends Component {
  render() {
    // Use JSS to calculate the styles
    if (!this.props.styleObject) return null;
    
    const jss = create();
    let selectorPrefix = this.props.selectorPrefix;
    jss.setup({
      generateClassName : (rule) => {
        //Split multiple, insert prefix
        return rule.name.split(",").map((item, index) => (index>0 ? "." : "") + selectorPrefix + item.trim()).join(", ");
      }
    });
    
    let sheet = jss.createStyleSheet(this.props.styleObject);
    let sheetText = sheet.toString();
    return (
      sheetText.length>0 && <style>{sheetText}</style>
    );
  }
}

export default StyleItem;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/StyleItem.js